/**
 * Alive Water — Product Configurator
 *
 * Scoped per section instance. No globals.
 * Regions + map, jug quantity → syncs hidden form fields,
 * frequency → selling_plan, then theme.AjaxProduct (same as PDP ProductForm):
 * water delivery + jug deposit, handleWaterDeliveryChange, errors, btn--loading,
 * ajaxProduct:added / cart drawer / Cross Sell.
 */
(function () {
  'use strict';

  const SEL = '[data-alive-configurator]';

  function bindAjaxProductForm(form) {
    if (!form || form.getAttribute('data-alive-ajax-product') === '1') return;
    if (typeof window.theme === 'undefined' || !window.theme.AjaxProduct) return;
    form.setAttribute('data-alive-ajax-product', '1');
    new window.theme.AjaxProduct(form);
  }

  function init(root) {
    if (root.__aliveInit) return;
    root.__aliveInit = true;

    const regionPills = root.querySelectorAll('[data-region]');
    const regionMapImg = root.querySelector('[data-region-map-img]');
    const jugOptions = root.querySelectorAll('[data-jug-option]');
    const jugsScroll = root.querySelector('[data-jugs-scroll]');
    const freqRoot = root.querySelector('[data-freq]');
    const freqTrigger = root.querySelector('[data-freq-trigger]');
    const freqPanel = root.querySelector('[data-freq-panel]');
    const freqLabel = root.querySelector('[data-freq-label]');
    const freqOptions = root.querySelectorAll('[data-freq-option]');
    const productForm = root.querySelector('form.alive-configurator__atc-form');
    const qtyInput = root.querySelector('[data-alive-qty-input]');
    const planInput = root.querySelector('[data-alive-selling-plan-input]');
    const noProductBtn = root.querySelector('[data-alive-no-product]');
    const errorEl = root.querySelector('[data-cart-error]');

    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const state = {
      region: null,
      quantity: null,
      sellingPlan: null,
    };

    function showError(el, text) {
      if (!el) return;
      el.textContent = text;
    }

    function syncFormFromState() {
      if (qtyInput && state.quantity != null) {
        qtyInput.value = String(state.quantity);
      }
      if (planInput) {
        planInput.value = state.sellingPlan || '';
      }
    }

    bindAjaxProductForm(productForm);

    /* ----------------------------- Regions ---------------------------- */
    regionPills.forEach((pill) => {
      pill.addEventListener('click', () => selectRegion(pill));
      if (pill.getAttribute('data-default') === 'true' && !state.region) {
        selectRegion(pill);
      }
    });
    if (!state.region && regionPills.length > 0) {
      selectRegion(regionPills[0]);
    }

    function selectRegion(pill) {
      regionPills.forEach((p) => {
        const match = p === pill;
        p.setAttribute('aria-pressed', match ? 'true' : 'false');
        p.classList.toggle('is-selected', match);
      });
      state.region = pill;

      const url = pill.getAttribute('data-map');
      if (url && regionMapImg && regionMapImg.getAttribute('src') !== url) {
        regionMapImg.style.opacity = '0';
        const next = new Image();
        next.onload = () => {
          regionMapImg.src = url;
          regionMapImg.alt = (pill.getAttribute('data-label') || 'Delivery region') + ' delivery map';
          requestAnimationFrame(() => {
            regionMapImg.style.opacity = '1';
          });
        };
        next.onerror = () => {
          regionMapImg.style.opacity = '1';
        };
        next.src = url;
      }
    }

    /* ---------------------------- Jug options ------------------------- */
    jugOptions.forEach((btn) => {
      btn.addEventListener('click', () => selectJug(btn, true));
      if (btn.getAttribute('data-default') === 'true' && !state.quantity) {
        selectJug(btn, false);
      }
    });
    if (!state.quantity && jugOptions.length > 0) {
      selectJug(jugOptions[0], false);
    }

    function selectJug(btn, userInitiated) {
      jugOptions.forEach((b) => {
        const match = b === btn;
        b.setAttribute('aria-pressed', match ? 'true' : 'false');
        b.classList.toggle('is-selected', match);
      });
      state.quantity = parseInt(btn.getAttribute('data-quantity'), 10) || 1;
      syncFormFromState();
      if (userInitiated && jugsScroll && btn && typeof btn.scrollIntoView === 'function') {
        btn.scrollIntoView({
          block: 'nearest',
          behavior: reduce ? 'auto' : 'smooth',
        });
      }
    }

    /* ------------------------ Frequency dropdown ---------------------- */
    if (freqRoot && freqTrigger && freqPanel) {
      freqPanel.style.height = '0px';

      freqTrigger.addEventListener('click', () => {
        if (freqRoot.getAttribute('data-freq-open') === 'true') closeFreq();
        else openFreq();
      });

      document.addEventListener('click', (e) => {
        if (freqRoot.getAttribute('data-freq-open') !== 'true') return;
        if (!freqRoot.contains(e.target)) closeFreq();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && freqRoot.getAttribute('data-freq-open') === 'true') {
          closeFreq();
          freqTrigger.focus();
        }
      });

      freqOptions.forEach((opt) => {
        opt.addEventListener('click', () => {
          selectFreq(opt);
          closeFreq();
        });
        if (opt.getAttribute('data-default') === 'true' && !state.sellingPlan) {
          selectFreq(opt);
        }
      });
    }

    function openFreq() {
      freqRoot.setAttribute('data-freq-open', 'true');
      freqTrigger.setAttribute('aria-expanded', 'true');
      if (reduce) {
        freqPanel.style.height = 'auto';
        return;
      }
      const h = freqPanel.scrollHeight;
      freqPanel.style.height = '0px';
      void freqPanel.offsetHeight;
      requestAnimationFrame(() => {
        freqPanel.style.height = h + 'px';
      });
      freqPanel.addEventListener('transitionend', function onEnd(e) {
        if (e.target !== freqPanel || e.propertyName !== 'height') return;
        freqPanel.removeEventListener('transitionend', onEnd);
        if (freqRoot.getAttribute('data-freq-open') === 'true') freqPanel.style.height = 'auto';
      });
    }

    function closeFreq() {
      if (reduce) {
        freqRoot.setAttribute('data-freq-open', 'false');
        freqTrigger.setAttribute('aria-expanded', 'false');
        freqPanel.style.height = '0px';
        return;
      }
      const h = freqPanel.scrollHeight;
      freqPanel.style.height = h + 'px';
      void freqPanel.offsetHeight;
      freqRoot.setAttribute('data-freq-open', 'false');
      freqTrigger.setAttribute('aria-expanded', 'false');
      requestAnimationFrame(() => {
        freqPanel.style.height = '0px';
      });
    }

    function selectFreq(opt) {
      freqOptions.forEach((o) => {
        const match = o === opt;
        o.setAttribute('aria-pressed', match ? 'true' : 'false');
        o.classList.toggle('is-selected', match);
      });
      state.sellingPlan = opt.getAttribute('data-selling-plan-id') || '';
      if (freqLabel) {
        freqLabel.textContent = opt.getAttribute('data-label') || opt.textContent.trim();
      }
      syncFormFromState();
    }

    if (planInput && planInput.value) {
      state.sellingPlan = planInput.value;
    }

    syncFormFromState();

    /* ---------------------- No product (editor / misconfig) ---------- */
    if (noProductBtn) {
      noProductBtn.addEventListener('click', () => {
        showError(errorEl, 'Product is not configured yet. Link a product in the theme editor.');
      });
    }

    /* Clear inline errors when theme dispatches success on this form */
    if (productForm && errorEl) {
      productForm.addEventListener(
        'ajaxProduct:added',
        () => {
          showError(errorEl, '');
        },
        true
      );
    }
  }

  function boot() {
    document.querySelectorAll(SEL).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll(SEL).forEach((node) => {
      node.__aliveInit = false;
      const f = node.querySelector('form.alive-configurator__atc-form');
      if (f) f.removeAttribute('data-alive-ajax-product');
      init(node);
    });
  });
})();
